import React from 'react'
import { Link } from 'react-router'

import Overlay from 'components/Overlay'
import LoadingLinear from 'components/Loading/LoadingLinear'
import SimpleTable from 'components/Tables/SimpleTable'
import CheckboxRow from 'components/Input/CheckboxRow'
import { PrevNextButtons } from '../PrevNextButtons'
import { useGetUsagePlansQuery } from 'src/generated/graphql'
import cn from 'classnames'

import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import useMount from 'react-use/lib/useMount'
import { Field } from 'redux-form'
import { vRequired } from 'components/Input/Input.validations'

export const SummaryStepComponent = props => {
  const { onBack, loading, formData, setHeadings } = props

  const usagePlansQuery = useGetUsagePlansQuery()

  useMount(() => {
    setHeadings &&
      setHeadings({
        heading: 'Last Step, you’re almost powered by Pickle.',
        subHeading:
          'See below a summary of your new Simply Awesome Mobile Service from Pickle. Now the easy part is clicking the green button, and you’re done. You can leave the rest to us.',
      })
  })

  if (usagePlansQuery.loading) {
    return <LoadingLinear />
  }

  const usagePlan = usagePlansQuery.data?.usagePlans?.filter(
    plan => plan.alias === 'mobile-service'
  )[0]

  if (!usagePlan) {
    return <div>Error: unable to load usage plan</div>
  }

  const monthlyCharge = formData.isPremiumNumber
    ? `$${usagePlan.monthlyCharge}/mth + $${formData.premiumNumberPrice}/mth (premium license)`
    : `$${usagePlan.monthlyCharge}/mth`

  const disabled = formData.isPremiumNumber
    ? !formData.number || !formData.confirmFees
    : !formData.number

  return (
    <div>
      <div className={cn(sText.descrip3, sMarg.mb30)}>
        We will send you an email with the next steps. You can also view the status of your new
        Mobile number in right here your Pickle Portal.
      </div>

      <SimpleTable>
        <div>
          <div>Number:</div>
          <div>{formData.number}</div>
        </div>
        <div>
          <div>Plan:</div>
          <div>{usagePlan.name}</div>
        </div>
        <div>
          <div>Plan Cost:</div>
          <div>{monthlyCharge} (ex GST)</div>
        </div>
      </SimpleTable>

      <div className={cn(sText.descrip5, sMarg.mt30)}>
        {formData.isPremiumNumber && (
          <Field
            name="confirmFees"
            component={CheckboxRow}
            style={{ margin: '30px 0' }}
            validate={[vRequired]}
          >
            I understand that this premium number is associated with a monthly payment of $
            {formData.premiumNumberPrice + usagePlan.monthlyCharge} and a 24 months contract.{' '}
            <Link target="_blank" to="/premium-mobile-service-terms">
              Learn more.
            </Link>
          </Field>
        )}
        <p>
          I wish to apply for the Virtual Mobile App described in this application form and
          acknowledge that if my application is accepted it will be provided on the terms and
          conditions set out in this application form and Our Customer Terms. If there is an
          inconsistency between this application form and Our Customer Terms, this application form
          applies instead of Our Customer Terms to the extent of that inconsistency.
        </p>
        <p>
          I acknowledge that I have had the opportunity to review the{' '}
          <a href="https://thinkpickle.com.au/terms" target="_blank">
            Terms and Conditions.
          </a>
        </p>
        <p>
          You agree and will ensure that any of your related bodies corporate which receive services
          connected with this application form and your representatives are aware, that Pickle may:
        </p>
        <p>
          (a) use and disclose information about you and each of them in accordance with Pickle’s
          Privacy Statement; and
        </p>
        <p>
          (b) give to, seek and obtain from, a credit reporting agency, information (including
          personal and credit information) about you to assess your creditworthiness.
        </p>
      </div>

      {loading && (
        <Overlay>
          Creating your mobile service... This can take a minute or two. You can always send our
          friendly support a message if you have any issues.
          <br />
          <br />
          <LoadingLinear />
        </Overlay>
      )}

      {!loading && (
        <PrevNextButtons
          next="I Agree"
          onBack={onBack}
          loading={loading}
          disabled={disabled || loading}
        />
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceForm/SummaryStep/SummaryStep.tsx